// defines custom column header title, width, and badge to each column
export const columnConfig = [
  { 
    field: 'reasonForTest', 
    title: 'Type of Test', 
    width: '150px', 
    badge: null 
  },
  { 
    field: 'totals', 
    title: 'Total Number of Test Results (Should equal the sum of Columns 2, 3, 7, and 8)', 
    width: '150px', 
    badge: { type: 'info', content: 1 } 
  },
  { 
    field: 'screeningBelow002', 
    title: 'Screening Tests with Results Below 0.02', 
    width: '150px', 
    badge: { type: 'info', content: 2 } 
  },
  { 
    field: 'screeningAbove002', 
    title: 'Screening Tests with Results 0.02 Or Greater', 
    width: '150px', 
    badge: { type: 'info', content: 3 } 
  },
  { 
    field: 'confirmationResults', 
    title: 'Number of Confirmation Tests Results', 
    width: '150px', 
    badge: { type: 'info', content: 4 } 
  },
  { 
    field: 'confirmation002To039', 
    title: 'Confirmation Tests with Results 0.02 Through 0.039', 
    width: '150px', 
    badge: { type: 'info', content: 5 } 
  },
  { 
    field: 'confirmationAbove004', 
    title: 'Confirmation Tests with Results 0.04 Or Greater', 
    width: '150px', 
    badge: { type: 'info', content: 6 } 
  },
];
